import { StyleSheet } from 'react-native';
import { grid } from '@shared/styles';

export const WorkflowComponentStyles = StyleSheet.create({
  container: {
    marginVertical: grid(1),
    paddingTop: grid(2),
    paddingHorizontal: grid(1),
    marginHorizontal: grid(2),
    borderTopWidth: 1,
    borderTopColor: '#E6E6E6',
  },
  textarea: {
    backgroundColor: '#F7F7F7',
    borderRadius: grid(1),
    padding: grid(1),
    paddingLeft: grid(2),
    paddingRight: grid(2),
    marginBottom: grid(1),
  },
  wrapper: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: grid(1),
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'transparent',
    marginVertical: grid(0.125),
  },
  label: {
    minHeight: 60,
  },
  error: {
    paddingLeft: grid(7),
    marginTop: grid(1.75),
    alignSelf: 'flex-start',
  },
});
